import axiosInstance from "@/axiosConfig";
import type { AdminNotificationCountsResponse } from "@/shared/types/adminNotifications.types";
import { getApiUrl } from "@/shared/utils/api";

export const AdminNotificationsService = {
  getCounts: async (): Promise<AdminNotificationCountsResponse> => {
    const response = await axiosInstance.get<AdminNotificationCountsResponse>(
      getApiUrl("/notification_counts"),
    );
    return response.data;
  },
};
